export enum LoanBegin {
  'ASAP' = 'ASAP',
  'UP_TO_MONTH' = 'UP_TO_MONTH',
  'UP_TO_FEW_MONTHS' = 'UP_TO_FEW_MONTHS',
  'UP_TO_HALF_YEAR' = 'UP_TO_HALF_YEAR',
  'OVER_HALF_YEAR' = 'OVER_HALF_YEAR',
  'TBD' = 'TBD',
}
